module.exports = __webpack_public_path__ + "img/file-table-box-multiple-outline.0bcaaa92.svg";